import { jsx as _jsx } from "react/jsx-runtime";
import dieselGeneratorIcon from "../../assets/dieselGenerator.png";
const sizeMap = {
    lg: "w-8 h-8",
    md: "w-6 h-6",
    sm: "w-4 h-4",
    xl: "w-12 h-12"
};
export const CatDieselGeneratorIcon = ({ className = "", size = "xl" }) => (_jsx("img", { alt: "Diesel Generator", className: `${sizeMap[size] ?? sizeMap.xl} mx-auto ${className}`, "data-test": "diesel-generator-icon", src: dieselGeneratorIcon }));
